import { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { BettingSlipAcceptStatus } from '../@types/api';
import { TicketAuthorizationMessage } from '../components/layouts/MainLayout';
import { useAudio } from '../contexts/AudioContext';
import { MessageType } from './useWebsocket';

type TicketAuthorizationMessageData = {
  [id: string]: MessageType<TicketAuthorizationMessage>;
};

const usePlayTicketAuthSound = () => {
  const isTicketAuthorizationPageRef = useRef(false);

  const { loopAudio: loopIncomingTicketAudio } = useAudio();

  const location = useLocation();

  const canPlayAuthorizationSound = useCallback((acceptStatus: BettingSlipAcceptStatus, reoffered: boolean) => {
    return acceptStatus === 'pending' && !reoffered;
  }, []);

  const ticketAuthorizationCallback = useCallback(
    (data: TicketAuthorizationMessageData) => {
      const message = Object.values(data)[0];
      const { acceptStatus, reoffered } = message.payload;

      if (canPlayAuthorizationSound(acceptStatus, reoffered)) {
        loopIncomingTicketAudio();
      }
    },
    [canPlayAuthorizationSound, loopIncomingTicketAudio]
  );

  useEffect(() => {
    isTicketAuthorizationPageRef.current = location.pathname.includes('ticket-authorization');
  }, [location.pathname]);

  return {
    ticketAuthorizationCallback,
  };
};

export default usePlayTicketAuthSound;
